<div
  class="parameters"
  [class.wrap]="isModal()"
  [class.f-muted]="isCell()"
  [class.f-body-s]="isCell()"
  [class.f-body-m]="!isCell()"
>
  @if (fleet().fuelTankCapacity?.fuelType; as fuelType) {
    <p [class.nowrap]="isModal()">
      {{ `${DictionaryCode.FUEL_TYPE}.${fuelType}` | translate }}
    </p>
  }

  @let lowDeck = fleet().additionalParameters.isLowDeck;
  @if (lowDeck != null) {
    <p [class.nowrap]="isModal()">
      {{ (lowDeck ? 'labels.lowDeck' : 'labels.standardDeck') | translate }}
    </p>
  }

  @if (fleet().generalInformation.type; as type) {
    <p [class.nowrap]="isModal()">
      {{ `${DictionaryCode.VEHICLE_TYPE}.${type}` | translate }}
    </p>
  }

  @let additionalParameters = fleet().additionalParameters;
  @if (additionalParameters.semiTrailerSize; as semiTrailerSize) {
    <p [class.nowrap]="isModal()">
      {{ `${DictionaryCode.SEMI_TRAILER_SIZE}.${semiTrailerSize}` | translate }}
    </p>
  }

  @if (additionalParameters.trailerSize; as trailerSize) {
    <p [class.nowrap]="isModal()">
      {{ `${DictionaryCode.TRAILER_SIZE}.${trailerSize}` | translate }}
    </p>
  }

  @if (isModal() && fleet().generalInformation; as generalInformation) {
    <p class="nowrap">
      {{ generalInformation.make }}
      {{ generalInformation.model }}
    </p>
  }
</div>
